<template>
    <div class="institutional-area md:mb4">
        <div class="secondary-articles-area">
            <a
                :href="'noticias/noticia/' + noticia.id"
                v-for="(noticia, index) in maisNoticias"
                :key="index"
            >
                <secondary-article
                    :category="stringCategoria(noticia.categoria)"
                    :text="noticia.noticia"
                    :date="noticia.data_noticia"
                    :img="noticia.imagens"
                />
            </a>
        </div>
        <div class="w-full flex flex-col gap-2">
            <article
                class="event-card flex-1"
                :style="{ backgroundImage: image_evento }"
            >
                <figure>
                    <div class="img">
                        <tag
                            class="bg-secondary text-black"
                            text="Próximo Evento"
                        />
                    </div>
                </figure>
            </article>
            <div class="card-text text-center">
                <p class="text text-lg ">Acesse nossa lista de eventos</p>

                <p class="my-2">
                    <router-link to="/sistema" class="my-4">
                        <b>Clique para se inscrever</b>
                    </router-link>
                </p>

                <p class="mt-4">
                    <router-link to="/sistema" class="btn-form my-2">
                        Participar
                    </router-link>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Tag from "./tag";
import SecondaryArticle from "./secondary-articles";
import axios from "axios";
export default {
    name: "institutional-area",
    components: {
        Tag,
        SecondaryArticle
    },
    props: ["maisNoticias"],

    created() {
        this.getProximoEvento();
    },

    data() {
        return {
            evento: [],
            image_evento: null
        };
    },

    methods: {
        getProximoEvento() {
            axios("proximo-evento").then(response => {
                this.evento = response.data.evento;
                this.image_evento =
                    'url("' +
                    response.data.evento.imagem_evento[0].imagem +
                    '")';
            });
        },

        stringCategoria(id) {
            switch (id) {
                case "1":
                    return "UGT Notícias";
                    break;
                case "2":
                    return "Palavra do Presidente";
                    break;
                case "3":
                    return "Comentário do Diretor";
                    break;
                default:
                    return "UGT Notícias";
            }
        }
    }
};
</script>

<style scoped lang="scss">
.card-text {
    @apply block;
    margin-top: 0.5rem;
    width: 100%;
    p {
        @apply text-black text-xs;
    }
}

.institutional-area {
    @media (max-width: 879px) {
        @apply flex flex-col mx-auto w-full items-center;
        max-width: 640px;
    }
    @media (min-width: 880px) {
        .event-card {
            @apply mt-10;
        }
        @apply flex flex-row w-full mx-auto justify-between;
    }

    /* Formatação card de eventos */
    .event-card {
        background-position: center !important;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-color: #fff !important;
        background: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6));
        //url('../../../../../img/bg/bg-events.png') no-repeat center;
        //background-size: cover;
        @apply text-center text-white bg-base-gray;
        @media (max-width: 879px) {
            @apply relative;
            width: 100%;
            min-height: 400px;
        }
        @media (min-width: 880px) {
            @apply relative ml-10;
            .card-text {
                p {
                    @apply text-base;
                }
            }
        }
        border-radius: 10px;
        padding: 10px;
    }

    /* Formatação da área de artigos secundários */
    .secondary-articles-area {
        @apply flex flex-col justify-between;
        a {
            @apply text-black;
        }
        @media (min-width: 880px) {
            max-width: 50%;
            @apply pr-10 border-r-2 border-light-gray;
            a {
                @apply border-b-2 border-light-gray pb-5 pt-5;
            }
            a:first-child {
                @apply pt-0;
            }
            a:last-child {
                @apply pb-0 border-b-0;
            }
        }
    }

    /* Formatação do botão Participar */
    .btn-form {
        @apply bg-primary text-white py-2 px-8 ml-2 mt-3 text-base italic rounded-md;
        min-width: 120px;
    }
    .btn-form:hover {
        background-color: #920002;
    }
    .btn-form:focus {
        outline: none;
    }
}
</style>
